import { DataSet } from '../../types';
import { DataAccessor, DataAccessorOptions } from '../../types/data-accessor.types';
import { PrimaryDataAccessor } from './PrimaryDataAccessor';
import { DerivedDataAccessor } from './DerivedDataAccessor';

/**
 * DataSetの種類に応じて適切なDataAccessorを作成するファクトリー関数
 * @param dataset 対象のデータセット
 * @param options アクセサのオプション
 * @returns 適切なDataAccessor実装
 */
export function createDataAccessor(
  dataset: DataSet,
  options: DataAccessorOptions = {}
): DataAccessor {
  if (dataset.type === 'primary' || dataset.type === 'ephemeral') {
    // PrimaryDataSetとEphemeralDataSetはdataを直接持つのでPrimaryDataAccessorを使用
    return new PrimaryDataAccessor(dataset, options);
  } else {
    // DerivedDataSetはoperationから再計算するのでDerivedDataAccessorを使用
    return new DerivedDataAccessor(dataset, options);
  }
}

// WeakMapを使用してDataAccessorインスタンスをキャッシュ
const accessorCache = new WeakMap<DataSet, DataAccessor>();

/**
 * DataSetに対するDataAccessorを取得（キャッシュ付き）
 * 同じDataSetに対しては同じDataAccessorインスタンスを返す
 * @param dataset 対象のデータセット
 * @param options アクセサのオプション
 * @returns DataAccessor
 */
export function getDataAccessor(
  dataset: DataSet,
  options: DataAccessorOptions = {}
): DataAccessor {
  // キャッシュから取得
  const cached = accessorCache.get(dataset);
  if (cached) {
    return cached;
  }

  // 新規作成してキャッシュ
  const accessor = createDataAccessor(dataset, options);
  accessorCache.set(dataset, accessor);
  return accessor;
}

/**
 * 指定されたDataSetのアクセサキャッシュをクリア
 * @param dataset 対象のデータセット
 */
export function clearDataAccessorCache(dataset: DataSet): void {
  accessorCache.delete(dataset);
}